module.exports = "https://bce.bdstatic.com/video-meeting/zh-cn/assert/no-meeting.87b9e9bf.png";